import { InsuranceOpsGetBrokerResponse } from "../../types/responses";

// All brokers go in this list. fetchPolicyDetails.Agency.Id is the key.
export const brokers: Record<string, InsuranceOpsGetBrokerResponse> = {
  "3000": {
    Name: "Dave Smith",
    Email: "brokerman@example.com",
    Phone: {
      AreaCode: "301",
      Prefix: "555",
      Suffix: "1212",
      Extension: "",
    },
    MailingAddress: {
      LineOne: "1000 Broker Ln",
      LineTwo: "",
      City: "Baltimore",
      StateRegion: "MD",
      PostalCode: "03456",
    },
    PrincipalProducer: {
      Id: 11111,
      Name: {
        Prefix: "",
        First: "Mr",
        Middle: "",
        Last: "Broker",
        Suffix: "",
      },
      Email: "mr.broker@example.com",
      Phone: {
        AreaCode: "000",
        Prefix: "111",
        Suffix: "2233",
        Extension: "00",
      },
      Address: {
        Id: 321312,
        LineOne: "9999 Broker Ln",
        LineTwo: "",
        City: "Tucson",
        County: null,
        StateRegion: "AZ",
        PostalCode: "123456",
        Country: "US",
        Township: null,
        Type: "Mailing",
        EffectiveDate: "2022-05-24T00:00:00",
        ExpirationDate: null,
        IsDefault: true,
        IsSeasonal: null,
      },
      Roles: ["PRIN", "PM"],
    },
  },
};
